import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/ia-e-integridad-de-datos-el-nuevo-desafio-regulatorio")({
  head: () => buildRouteHead("/es/ia-e-integridad-de-datos-el-nuevo-desafio-regulatorio", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/webinars/ia-en-life-sciences-cumplimiento-gxp", replace: true });
  },
});
